export type ChatMessage = {
    id?: string,
    name: string,
    content: string,
    recipients?: Array<{
        userId: string,
        name: string,
        recipientType?: string | "admin",
        companyId?: string
    }>,
    user?: {
        id: string,
        name: string,
        companyId?: string
        firstname?: string;
        surname?: string
    },
    groupId?: string,
    createdAt?: Date,
    mail?: boolean,
    source?: 'admin' | 'client',
    domainId?: string,
    sessionId?: string,
    filename?: string,
    type?: string,
    edited?: number,
    editedAt?: Date,
    nonChatContent?: {
        subject: { id: number},
        type: string
    }
};

export enum ChatEventsName {
    OnChat,
    OnDelete,
    OnEdit
}

export type ChatEvent = {
    event: ChatEventsName,
    data: any
};
